export default {
  information: {
    button: 'ข้อมูลการใช้งาน',
    title: 'วิธีนำเข้ารายการลา',
    download: 'ดาวน์โหลดตัวอย่าง (.xlsx)',
    prepare:
      'เลือกบริษัทและดาวน์โหลดไฟล์ตัวอย่าง คงชื่อชีต leave ลำดับคอลัมน์ และ 3 แถวแรกไว้ คัดลอกแถวตัวอย่างไปแถวที่ 4 เป็นต้นไปแล้วเปลี่ยนเป็นข้อมูลจริง กำหนด id ของแต่ละแถวข้อมูลเป็นตัวเลข (1, 2, 3, ...) แถวที่ id เป็น example หรือ instructions จะไม่ถูกนำเข้า และไม่ควรเว้นแถวว่างระหว่างรายการ',
    format:
      'เก็บ start และ end เป็นข้อความรูปแบบ YYYY-MM-DD และ start_time กับ end_time เป็นข้อความรูปแบบ HH:mm เช่น 08:30 และ 10:30 การลารายชั่วโมงต้องระบุเวลาทั้งสองช่องและวันสิ้นสุดให้ถูกต้องเมื่อข้ามคืน การลาเต็มวันหรือครึ่งวันเว้นเวลาได้',
    values:
      'employee_code ต้องเป็นรหัสพนักงานของบริษัทที่เลือก type คือ ID ประเภทการลาที่ตั้งค่าไว้ของบริษัท สอบถาม ID ที่ถูกต้องจากผู้ดูแลระบบ ส่วน time_unit: 1 = เต็มวัน, 2 = ครึ่งวันเช้า, 3 = ครึ่งวันบ่าย, 4 = รายชั่วโมง กำหนด emergent และ block เป็น true หรือ false และระบุเหตุผลใน reason',
    upload:
      'บันทึกไฟล์ที่เตรียมแล้วเป็น .xlsx และกด Upload หลังโหลดข้อมูลบริษัทสำเร็จ รอระบบเข้าคิวและประมวลผลไฟล์',
    result:
      'กด Refresh เพื่อโหลดผลล่าสุด ตรวจรหัสพนักงาน สถานะ และรายละเอียดข้อผิดพลาดของแต่ละแถว ระบบแสดงเฉพาะผลนำเข้าล่าสุด โดย Refresh จะปิดจนกว่าจะมีงานนำเข้า แก้ไขและนำเข้าใหม่เฉพาะแถวที่ไม่สำเร็จ เพื่อไม่ให้รายการที่สำเร็จแล้วซ้ำ'
  },
  form: {
    'import-leave-file': 'Upload File (.csv , .xlsx)',
    title: {
      'import-leave': 'Leave Day Employee Document Management'
    }
  },
  'import-table': {
    row: 'ลำดับ',
    empCode: 'รหัสพนักงาน',
    detail: 'รายละเอียด',
    status: 'สถานะ'
  }
}
